import axiosInstance from 'src/config/axios.config';
import { API_ENDPOINTS } from 'src/config/api.config';

// Interface definitions
export type OvertimeStatus = 'PENDING' | 'APPROVED' | 'REJECTED' | 'CANCELLED' | 'EXPIRED';

export interface OvertimeRequestDto {
  id: string;
  employeeId: string;
  employeeName: string | null;
  branchName: string | null;
  attendanceId: string;
  checkInTime: string | null;
  declaredEndTime: string | null; // null = "Belirsiz" (open-ended declaration)
  reason: string | null;
  status: OvertimeStatus;
  createdAt: string;
  approvedBy: string | null;
  approvedAt: string | null;
  reviewNotes: string | null;
}

// Translation maps for display
export const OVERTIME_STATUS_LABELS_TR: Record<OvertimeStatus, string> = {
  PENDING: 'Onay Bekliyor',
  APPROVED: 'Onaylandı',
  REJECTED: 'Reddedildi',
  CANCELLED: 'İptal',
  EXPIRED: 'Süresi Doldu',
};

export const OVERTIME_STATUS_COLORS: Record<
  OvertimeStatus,
  'warning' | 'success' | 'error' | 'info' | 'default'
> = {
  PENDING: 'warning',
  APPROVED: 'success',
  REJECTED: 'error',
  CANCELLED: 'default',
  EXPIRED: 'info',
};

// Overtime API functions
export const overtimeApi = {
  async getOvertimeRequests(params?: {
    branchId?: string;
    status?: OvertimeStatus;
  }): Promise<OvertimeRequestDto[]> {
    const response = await axiosInstance.get<OvertimeRequestDto[]>(API_ENDPOINTS.OVERTIME, {
      params,
    });
    return response.data;
  },

  async getPendingCount(): Promise<number> {
    const response = await axiosInstance.get<{ pendingCount: number }>(
      `${API_ENDPOINTS.OVERTIME}/pending-count`
    );
    return response.data.pendingCount;
  },

  async approveOvertime(id: string, notes?: string): Promise<OvertimeRequestDto> {
    const response = await axiosInstance.post<OvertimeRequestDto>(
      `${API_ENDPOINTS.OVERTIME}/${id}/approve`,
      { reviewNotes: notes || undefined }
    );
    return response.data;
  },

  async rejectOvertime(id: string, notes?: string): Promise<OvertimeRequestDto> {
    const response = await axiosInstance.post<OvertimeRequestDto>(
      `${API_ENDPOINTS.OVERTIME}/${id}/reject`,
      { reviewNotes: notes || undefined }
    );
    return response.data;
  },
};
